import axiosInstance from './axiosConfig';

export const LABEL_COLORS = [
  '#1a73e8', '#d93025', '#f9ab00', '#188038', '#9334e6',
  '#e37400', '#047a6f', '#c5221f', '#1967d2', '#5f6368',
];

export const LABEL_ICONS = [
  'label', 'star', 'bookmark', 'flag', 'work',
  'home', 'people', 'priority', 'travel', 'shopping',
];

export const fetchLabels = async (includeHidden = true) => {
  const response = await axiosInstance.get('/api/labels', {
    params: { includeHidden: includeHidden ? 'true' : 'false' },
  });
  return response.data;
};

export const createLabel = async (payload) => {
  const response = await axiosInstance.post('/api/labels', payload);
  return response.data;
};

export const updateLabel = async (labelId, payload) => {
  const response = await axiosInstance.put(`/api/labels/${labelId}`, payload);
  return response.data;
};

export const deleteLabel = async (labelId) => {
  const response = await axiosInstance.delete(`/api/labels/${labelId}`);
  return response.data;
};

export const reorderLabels = async (orderedIds) => {
  const response = await axiosInstance.patch('/api/labels/reorder', { orderedIds });
  return response.data;
};

export const fetchLabelMails = async (labelId, { page = 1, limit = 50 } = {}) => {
  const response = await axiosInstance.get(`/api/labels/${labelId}/mails`, {
    params: { page, limit },
  });
  return response.data;
};

export const fetchLabelAssignments = async (mails) => {
  const response = await axiosInstance.post('/api/labels/assignments', { mails });
  return response.data;
};

export const assignLabelToMail = async (labelId, mailIdentity) => {
  const response = await axiosInstance.post(`/api/labels/${labelId}/assign`, mailIdentity);
  return response.data;
};

export const unassignLabelFromMail = async (labelId, mailIdentity) => {
  const response = await axiosInstance.post(`/api/labels/${labelId}/unassign`, mailIdentity);
  return response.data;
};

export const bulkAddLabel = async (labelId, mails) => {
  const response = await axiosInstance.post('/api/emails/bulk/add-label', { labelId, mails });
  return response.data;
};

export const bulkRemoveLabel = async (labelId, mails) => {
  const response = await axiosInstance.post('/api/emails/bulk/remove-label', { labelId, mails });
  return response.data;
};

export const buildMailIdentity = (mail) => {
  if (!mail) return {};
  const isImap = mail.source === 'imap' || mail.uid != null;
  return {
    mailId: !isImap ? (mail._id || mail.id) : undefined,
    uid: isImap ? (mail.uid ?? mail.imapUid) : undefined,
    messageId: mail.messageId || '',
    mailbox: mail.mailbox || 'INBOX',
    subject: mail.subject || '',
    from: mail.from || '',
    snippet: mail.preview || '',
    date: mail.createdAt || mail.date || null,
  };
};

export const resolveMailLabelKey = (mail) => {
  if (!mail) return '';
  if (mail._id) return String(mail._id);
  if (mail.messageId) return `mid:${mail.messageId}`;
  if (mail.uid != null || mail.imapUid != null) {
    return `uid:${mail.mailbox || 'INBOX'}:${mail.uid ?? mail.imapUid}`;
  }
  return '';
};
